import React, { ReactElement } from 'react';
import isEqual from 'lodash.isequal';
import { config } from 'b2b-apps/shop/config';
import { useTranslate } from 'b2b-apps/shop/i18n/hooks';
import { EnhancedComponentProps, EnhancedComponentType, InjectedProps, WrappedComponentType } from './';

export const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const t = useTranslate();

    const injectedProps: InjectedProps = {
      defaultTitle: t(
        '{shopName}',
        { shopName: config.shopName },
        'Used as default page title',
      ),
      titleTemplate: t(
        '%s | {shopName}',
        { shopName: config.shopName },
        'Page title template, %s is a placeholder for the dynamic page name',
      ),
    };

    return <Component {...props} {...injectedProps} />;
  };

  return React.memo(WithContainer, (prevProps, nextProps) => isEqual(prevProps, nextProps));
};
